var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9975 22.4217C17.3634 22.4217 16.8509 21.9092 16.8509 21.2751V19.4979H15.131C14.4969 19.4979 13.9844 18.9854 13.9844 18.3513C13.9844 17.7172 14.4969 17.2047 15.131 17.2047H16.8509V15.4298C16.8509 14.7969 17.3634 14.2832 17.9975 14.2832C18.6316 14.2832 19.1441 14.7969 19.1441 15.4298V17.2047H20.8525C21.4866 17.2047 21.9991 17.7172 21.9991 18.3513C21.9991 18.9854 21.4866 19.4979 20.8525 19.4979H19.1441V21.2751C19.1441 21.9092 18.6316 22.4217 17.9975 22.4217Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3511 1.58203C7.36304 1.58203 4.94141 4.04033 4.94141 7.06963C4.94141 10.1012 7.36304 12.5572 10.3511 12.5572C13.3392 12.5572 15.7608 10.1012 15.7608 7.06963C15.7608 4.04033 13.3392 1.58203 10.3511 1.58203Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7989 14.1094H7.64474C4.58674 14.1094 2 16.7339 2 19.8355C2 20.4133 2 21.1024 2.10663 21.6861C2.11351 21.725 2.11581 21.7652 2.12154 21.803C2.15708 22.0209 2.38182 22.2215 2.70516 22.2215H9.26718C9.63179 22.2215 9.95972 22.0002 10.095 21.662L12.6325 15.3431C12.8698 14.7526 12.4352 14.1094 11.7989 14.1094Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomer);
export default __webpack_public_path__ + "static/media/add_customer.58c9fe04dd8a5b47311084cd602fcc7d.svg";
export { ForwardRef as ReactComponent };